import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SpaCountState from "../states/spaCount.state";
import {fetchSpaCount} from "../actions/spas.actions";

const initialState: SpaCountState = {
  loading: false,
  online:0,
    total:0,
  error: null,
};

const SpaCountSlice = createSlice({
  name: 'spaCount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpaCount.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.online = action.payload.online;
        state.total = action.payload.total;
      })
      .addCase(fetchSpaCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default SpaCountSlice.reducer;